import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { ValidationService } from '../../shared/providers/validation.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LoaderService } from '../../shared/providers/loader.service';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { CommonService } from '../../shared/providers/common.service';
import { DashboardService } from '../../shared/providers/dashboard.service';
import { ToastService } from '../../shared/providers/toast.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IPropertyCard } from '../../shared/models/propertycard';
enum Tabs {
  OnMarket = 1,
  OffMarket = 2,
}
export enum OfferStatus {
  New = 451,
  Reviewed = 452,
  CounterAccepted = 453,
  CounterDeclined = 454,
  UnderContract = 455,
  Closed = 456,
  Rejected = 457,
  OfferModified = 458,
  Draft = 459,
  OfferAccepted = 460,
  Countered = 461,
  HardContract = 462,
  OnHold = 463,
  Delete = 464,
  Resume = 465,
  Cancelled = 466,
  Declined = 467,
  NoActivitySinceLast10Days = 0,
  Reset = -1
}
interface IProperty extends IPropertyCard {
  DateOnMarket?: Date;
  CharacteristicsId: number;
}
@Component({
  selector: 'app-broker-properties',
  templateUrl: './broker-properties.component.html',
  styleUrls: ['./broker-properties.component.css']
})
export class BrokerPropertiesComponent implements OnInit {

  constructor(private router: Router, public Validation: ValidationService, private modalService: BsModalService, private _toastService: ToastService, private _dashboardService: DashboardService, private _commonService: CommonService, public authService: AuthenticationService, private http: HttpClient, private Loader: LoaderService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (this.Validation.IsValid(params["activetab"])) {
        this.activeTab = parseInt(params["activetab"]);
      }
    });
  }
  protected readonly BASE_URL: string = environment.base_url;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  loggedUserDetails: any;
  modalRefOM: BsModalRef;
  modalRefShareListing: BsModalRef;
  rowCount = 0;
  dtOptions = {};
  selectedColumns = [];
  selectedColumns1 = [];
  properties: any[];
  selectedRows: any[]=[];
  selectedStatus: any[] | null;
  searchText: string = "";
  tdcount: number = 7;
  IsLoading: boolean = false;
  tabs = Tabs;
  activeTab = Tabs.OnMarket;
  IsLastverfied: boolean = true;
  sharedOmProperties: number[] = [];
  inputStates = [];
  //defaultText: IMultiSelectTexts = {
  //  checked: 'Status selected',
  //  checkedPlural: 'Status selected',
  //  defaultTitle: '- Select -'
  //};
  defaultSettings = {
    singleSelection: false,
    text: "- Select -",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  ngOnInit() {

    this._commonService.GetOfferStatus(8).subscribe(response => {
      this.inputStates = response.map(o => {
        return { id: o.Id, name: o.Description };
      });
    });
    if (localStorage.getItem("deal_listings_selectedColumns_Lastverified") != null && localStorage.getItem("deal_listings_selectedColumns_Lastverified") != '' && localStorage.getItem("deal_listings_selectedColumns_Lastverified") != undefined) {
      localStorage.removeItem("deal_listings_selectedColumns_Lastverified");
    }
    if (localStorage.getItem("deal_listings_selectedColumns_prospects") != null && localStorage.getItem("deal_listings_selectedColumns_prospects") != '' && localStorage.getItem("deal_listings_selectedColumns_prospects") != undefined) {
      localStorage.removeItem("deal_listings_selectedColumns_prospects");
    }
    if (localStorage.getItem("deal_listings_selectedColumns_LS") != null && localStorage.getItem("deal_listings_selectedColumns_LS") != '' && localStorage.getItem("deal_listings_selectedColumns_LS") != undefined) {
      localStorage.removeItem("deal_listings_selectedColumns_LS");
    }
    this.loggedUserDetails = this.authService.user;

    this.LoadContents();

  }

  LoadContents() {
    this.BindColumns();
    const that = this;
    const filter =
    {
      UserId: this.loggedUserDetails.Id,
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      "pageLength": 50,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[1, "asc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = filter;
        this.IsLoading = true;
        that.searchText = dataTablesParameters.search.value;
        dataTablesParameters.Extra_param.ActiveStatus = this.activeTab == this.tabs.OnMarket ? 'OnMarket' : 'OffMarket';
        dataTablesParameters.Extra_param.OfferStatus = this.selectedStatus;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/myproperties/' + true,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.properties = resp.data ? resp.data : [];
            let checkedCount = 0;
            that.properties.forEach(item => {
              if (this.selectedRows.findIndex(x => x.Id == item.Id) > -1) {
                item.IsSelected = true;
                checkedCount++;
              }
              item.Remaining_Term = this.Validation.remainingTermForCardandTables(item.LeaseExpiration, item.LeaseCommencementDate);
            });
            this.selectAll = false;
            this.autoSelectAll();
            this.rowCount = resp.recordsTotal;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [
        { data: 'PropertySequenceId' },
        { data: 'PropertySequenceId' },
        { data: 'PropertyName' },
        { data: 'SalesforceId' },
        { data: 'State' },
        { data: 'City' },
        { data: 'ShowProspectToSeller' },
        { data: 'Price' },
        { data: 'OffersCount' },
        { data: 'Sellers' },
        { data: 'TotalFileCount' },
        { data: 'Prospects' },
        { data: 'RentNOI' },
        { data: 'Rating' },
        { data: 'CapRate' },
        { data: 'RemainingTerm' },
        { data: 'LeaseStructure' },
        { data: 'BuildingSize' },
        { data: 'LastVerifiedDate' },
      ]
    };
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  defaultTypeText= {
    defaultTitle: 'Select Columns',
  };
  hideColumn(col: number) {
    if (this.activeTab == this.tabs.OnMarket) {
      if (col == 11) {
        return false;
      }
      else if (col == 12) {
        return true;
      }
      else if (this.selectedColumns.indexOf(col) > -1) {
        return false; // show
      }
      else {
        return true; // hide
      }
    }
    else {
      if (col == 11 ||col==13) {
        return true;
      }
      else if (this.selectedColumns1.indexOf(col) > -1) {
        return false; // show
      }
      else {
        return true; // hide
      }
    }
  }


  tableColumns: collapseColumns[] = [];
  tableColumns1: collapseColumns[] = [];
  BindColumns() {
    let selectedValues = [];
    if (this.activeTab == this.tabs.OffMarket) {
      this.tableColumns1 = [
        { id: 1, name: 'Asking Price' },
        { id: 2, name: 'Offers' },
        { id: 3, name: 'Seller Name' },
        { id: 4, name: 'Files' },
        { id: 5, name: 'Rent NOI' },
        { id: 6, name: 'Credit Rating' },
        { id: 7, name: 'Cap Rate' },
        { id: 8, name: 'Remaining Term' },
        { id: 9, name: 'Lease Structure' },
        { id: 10, name: 'Area (SQ FT)' },
        { id: 12, name: 'Last Verified date' },
        { id: 14, name: 'Share Prospects with Seller' },
      ]
    }
    else {
      this.tableColumns = [
        { id: 1, name: 'Asking Price' },
        { id: 2, name: 'Offers' },
        { id: 3, name: 'Seller Name' },
        { id: 4, name: 'Files' },
        { id: 5, name: 'Rent NOI' },
        { id: 6, name: 'Credit Rating' },
        { id: 7, name: 'Cap Rate' },
        { id: 8, name: 'Remaining Term' },
        { id: 9, name: 'Lease Structure' },
        { id: 10, name: 'Area (SQ FT)' },
        { id: 13, name: 'Prospects' },
        { id: 14, name: 'Share Prospects with Seller' },

      ]
    }
    if (localStorage.getItem("deal_listings_selectedColumns_LS") != null && localStorage.getItem("deal_listings_selectedColumns_LS") != '' && localStorage.getItem("deal_listings_selectedColumns_LS") != undefined) {
      if (this.activeTab == this.tabs.OffMarket) {
        let selectedData = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_LS"));
        if (selectedData.indexOf(12) <= -1) {
          if (localStorage.getItem("deal_listings_selectedColumns_Lastverified") != null && localStorage.getItem("deal_listings_selectedColumns_Lastverified") != '' && localStorage.getItem("deal_listings_selectedColumns_Lastverified") != undefined) {
            {
              let verifiedStatus = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_Lastverified"));
              if (verifiedStatus == true) {
                selectedData.push(12);
              }
            }
          }
          else {
            selectedData.push(12);
            localStorage.setItem("deal_listings_selectedColumns_Lastverified", JSON.stringify(true));
          }
        }
        if (selectedData.indexOf(13) > -1) {
          selectedData = selectedData.filter(f => f.Id != 13);
          localStorage.setItem("deal_listings_selectedColumns_prospects", JSON.stringify(true));
        }
        localStorage.setItem("deal_listings_selectedColumns_LS", JSON.stringify(selectedData));
      }
      else {
        let selectedData = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_LS"));
        if (selectedData.indexOf(13) <= -1) {
          if (localStorage.getItem("deal_listings_selectedColumns_prospects") != null && localStorage.getItem("deal_listings_selectedColumns_prospects") != '' && localStorage.getItem("deal_listings_selectedColumns_prospects") != undefined) {
            {
              let verifiedStatus = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_prospects"));
              if (verifiedStatus == true) {
                selectedData.push(13);
              }
            }
          }
          else {
            selectedData.push(13);
            localStorage.setItem("deal_listings_selectedColumns_prospects", JSON.stringify(true));
          }
        }
        if (selectedData.indexOf(12) > -1) {
          selectedData = selectedData.filter(f => f.Id != 12);
          localStorage.setItem("deal_listings_selectedColumns_Lastverified", JSON.stringify(true));
        }
        localStorage.setItem("deal_listings_selectedColumns_LS", JSON.stringify(selectedData));
      }
    }

    if (localStorage.getItem("deal_listings_selectedColumns_LS") != null) {
      if (this.activeTab == this.tabs.OffMarket) {
        this.selectedColumns1 = [];
        this.selectedColumns1 = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_LS"));

      }
      else {
        this.selectedColumns = [];
        this.selectedColumns = JSON.parse(localStorage.getItem("deal_listings_selectedColumns_LS"));
      }
    }
    else {
      if (this.activeTab == this.tabs.OffMarket) {
        this.selectedColumns1 = [];
        this.tableColumns1.forEach(item => {
          this.selectedColumns1.push(item.id);
        });
      }
      else {
        this.selectedColumns = [];
        this.tableColumns.forEach(item => {
          this.selectedColumns.push(item.id);
        });

      }

    }

    this.onRedirection();
  }

  onRedirection() {
    localStorage.setItem("deal_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
    if (this.activeTab == this.tabs.OnMarket) {
      let total = this.selectedColumns.length + 5;
      this.tdcount = total;
    }
    else {
      let total = this.selectedColumns1.length + 4;
      this.tdcount = total;
    }

  }

  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }

  onTabClick(tab) {
    this.activeTab = tab;
    this.resetSelectedRows();
    this.dtElement.dtInstance.then(x => x.draw());
    this.LoadContents();

  }

  selectedProperties: IProperty[];
  openModalForShareListing(template: TemplateRef<any>, classes: any) {
    //this.selectedProperties = this.selectedRows;
    this.selectedProperties = this.properties.filter(x => x.IsSelected == true)
    if (this.selectedProperties.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 item.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.modalRefShareListing = this.modalService.show(template, { class: classes });
    }
  }
  openModalForShareOM(template: TemplateRef<any>, classes: any) {
    this.sharedOmProperties = this.properties.filter(x => x.IsSelected == true).map(x => x.Id);
    if (this.sharedOmProperties.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      let sharedOMlength = this.sharedOmProperties.length;
      let fileExist = this.properties.filter(x => x.IsSelected == true && x.IsOMExists==0);
      let fileLength = fileExist != null ? fileExist.length : 0;
      if (fileLength == sharedOMlength) {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'OM files not available for the selected properties.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      else {
        this.modalRefOM = this.modalService.show(template, { class: classes });
      }
    }
  }

  Gettooltipcontent(content: any) {
    var result = '';
    if (content) {
      var type = content.split(',')
      var count = type.length - 1;
      result = type[0] + (count > 0 ? ', ' + count + '+' : '');
    }
    return result;
  }
  onChange(e) {
    if (this.activeTab == this.tabs.OffMarket) {
      localStorage.setItem("deal_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns1));

      if (this.selectedColumns1.indexOf(12) > -1) {
        localStorage.setItem("deal_listings_selectedColumns_Lastverified", JSON.stringify(true));
      }
      else {
        localStorage.setItem("deal_listings_selectedColumns_Lastverified", JSON.stringify(false));
      }
    }
    else {
      localStorage.setItem("deal_listings_selectedColumns_LS", JSON.stringify(this.selectedColumns));
      if (this.selectedColumns1.indexOf(13) > -1) {
        localStorage.setItem("deal_listings_selectedColumns_prospects", JSON.stringify(true));
      }
      else {
        localStorage.setItem("deal_listings_selectedColumns_prospects", JSON.stringify(false));
      }

    }
  }

  advanceSearch() {
       this.dtElement.dtInstance.then(x => x.draw());
  }

  reset() {
       this.selectedStatus = [];
    this.dtElement.dtInstance.then(x => x.search(this.searchText).draw());
  }

  setSellerPrivilage(event, propertyId) {
    let status = event;
    this._dashboardService.saveSellerVisibilityForProspect(propertyId, status).subscribe(res => {
    })
  }

  selectAll = false;
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.properties.find(x => x.Id == Id);
      this.selectedRows.push(prop);
    }
    else {

      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.properties.filter(x => x.IsSelected == true).length == this.properties.length && this.properties.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  preserveSelectedRows() {
    localStorage.setItem("livelistingbroker_selectedRows", JSON.stringify(this.selectedRows));
    localStorage.setItem("livelisting_selectedRowsbroker_currentTab", JSON.stringify(this.activeTab));
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.properties.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.properties) {
      this.properties.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }

  removeProperty(propertyId: number) {
    this.selectAll = false;
    let prop = this.properties.find(x => x.Id == propertyId);
    if (prop) {
      prop.IsSelected = false;
    }
    this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == propertyId), 1);
    if (propertyId == 0) {
      this.resetSelectedRows();
    }
    this.preserveSelectedRows();
  }


}

